import React, { useEffect } from 'react';
import ReactQuill, { Quill, ReactQuillProps } from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const ReactQuillEditor = ({ value, onChange, modules, formats, ...props }: ReactQuillProps): JSX.Element => {
  useEffect(() => {
    if (typeof window !== 'undefined' && !window.Quill) {
      window.Quill = Quill;
    }
  }, []);

  return <ReactQuill value={value} onChange={onChange} modules={modules} formats={formats} {...props} />;
};

export default ReactQuillEditor;
